import { Image } from '@silvertours/common-landingpages-view';
import { http } from '@silvertours/front-shared';
import { MediaLegacy } from '@silvertours/front-legacy-shared';
import { useState } from 'react';
import { SearchForm } from '../SearchForm';
import {
  BackgroundImage,
  MobileSearchContainer,
  SearchFormContainer,
} from './NewSearch.styles';
import { StageContentContainer } from './Stage.styles';
import { SearchWizard } from '../SearchWizard';
import { useSubmitHandler } from '../SearchFormLegacy';
import { useSearchContext } from '../SearchFormLegacy/context';

type Props = {
  image: MediaLegacy.ImageProps | Image;
};

const NewSearchContainer = ({ image }: Props) => {
  const [showWizard, setShowWizard] = useState(false);

  const action = () => {
    setShowWizard(true);
  };

  const { state } = useSearchContext();
  const submitHandler = useSubmitHandler();

  if (showWizard) {
    return (
      <SearchWizard
        onClose={() => setShowWizard(false)}
        onConfirm={() => {
          submitHandler(
            state,
            '',
            () => {},
            (error: http.AxiosError) => {
              // TODO: handle errors
              console.error(error);
            },
          );
        }}
      />
    );
  }

  return (
    <MobileSearchContainer>
      <BackgroundImage
        {...image}
        id="stage-image-mobile"
        fill
        priority
        style={{
          objectFit: 'cover',
        }}
      />
      <StageContentContainer>
        <SearchFormContainer>
          <SearchForm searchAction={action} />
        </SearchFormContainer>
      </StageContentContainer>
    </MobileSearchContainer>
  );
};

export { NewSearchContainer };
